/************************************************************
 Consultation Namespace
 ************************************************************/

window.consult = {
    _action:null,
    _callback:null,
    _row:null,
    // Execute Action
    executeAction:function (action, row, callback) {
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);

        this._action = action;
        this._callback = callback;
        this._row = row;

        debug.log(wfId, actionId);

        // Cancel Requisition
        if (actionId == 3) {
            consult.openReason(consult.cancelReasonModalHandler);
        }
        // Schedule Requisition
        else if ((wfId == 10 || wfId == 13) && actionId == 6) {
            consult.openRequisitionScheduler(consult.requisitionSchedulerHandler);
        } else if(actionId == 23 && wfId == 10){
            var url = "/consult/consultation_requisition_internal_report?requisition_id="+action.task_id+"&patient_id="+consult._row.patient_id;

            Hades.showDocument(url);

            consult._callback(true, consult._action, consult._row);
        } else if(actionId == 23 && wfId != 10){
            var url = "/consult/consultation_requisition_report?requisition_id="+action.task_id+"&patient_id="+consult._row.patient_id;

            Hades.showDocument(url);

            consult._callback(true, consult._action, consult._row);
        }
        // Other actions
        else {
            consult.executeGenericAction();
        }
    },
    // Execute Generic Action
    executeGenericAction:function () {
        // Show alert for actions without undo
        if(parseInt(consult._action.wf_action_id) == 19 && !confirm(Hades.markAsExecutedWarning())){
            consult._callback(true, consult._action, consult._row);
            return;
        } else if(parseInt(consult._action.wf_action_id) == 34 && !confirm(Hades.delegateWarning())){
            consult._callback(true, consult._action, consult._row);
            return;
        }

        workflow.executeAction(consult._action, consult._callback, consult._row);
    },
    // Open Reason
    openReason:function (callback) {
        var params = {
            task_id:consult._action.task_id,
            wf_id:consult._action.wf_id,
            wf_status_id:consult._action.to_state_id,
            wf_action_id:consult._action.wf_action_id};

        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                consult._callback(false, consult._action, consult._row);
            });
    },
    // Cancel Requisition
    cancelReasonModalHandler:function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id:consult._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            cancel_date:data.date,
            cancel_hour:data.hour,
            wf_id:consult._row.wf_id,
            wf_status_id:consult._row.wf_status_id,
            wf_action_id:data.actionId};

        $.post('/consult/cancel_requisition', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    consult._callback(false, consult._action, consult._row);
                } else {
                    consult._callback(true, consult._action, consult._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                consult._callback(false, consult._action, consult._row);
            });
    },
    // Open Reason
    openRequisitionScheduler:function (callback) {

        $.get('/consult/schedule_requisition', {requisition_id:consult._row.task_id}, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $('#dialog').remove();
                $('body').append('<div id="dialog"></div>');

                $('#dialog').append(data).dialog({
                    width: 530,
                    title:$('#dialog').find('#consultation-requisition-schedule-ct').attr('data-title'),
                    modal: true,
                    closeText: ""
                });

                $('#consultation-requisition-schedule-ct').bind('onRequisitionScheduleConfirm', callback);

                Hades.hideLoading();

                consult._callback(true, consult._action, consult._row);
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();

                consult._callback(false, consult._action, consult._row);
            });
    },
    requisitionSchedulerHandler:function(event, data) {

        Hades.showLoading();

        var params = {
            requisition_id:consult._row.task_id,
            professional_id:data.professional_id,
            is_external:data.is_external,
            provider_id:data.provider_id,
            date:data.date,
            hour:data.hour,
            transport_type_id:data.transport_type_id,
            priority_type_id:data.priority_type_id};

        $.post('/consult/schedule_requisition_appointment', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    consult._callback(false, consult._action, consult._row);
                } else {
                    consult._callback(true, consult._action, consult._row);
                }

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                consult._callback(false, consult._action, consult._row);
            });
    }
};